import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { PersonalizationCoreModule } from '@spartacus/tracking/personalization/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let PersonalizationModule = /*#__PURE__*/(() => {
  class PersonalizationModule {
    static {
      this.ɵfac = function PersonalizationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PersonalizationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PersonalizationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [PersonalizationCoreModule]
      });
    }
  }
  return PersonalizationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of personalizatiion
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PersonalizationModule };
